module.exports = __webpack_public_path__ + "static/img/COC2023-33.c1f847a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-33.png
// module id = pwSo
// module chunks = 0